import { render, staticRenderFns } from "./RoundDisplay.vue?vue&type=template&id=f8fa05f8&scoped=true"
import script from "./RoundDisplay.vue?vue&type=script&lang=js"
export * from "./RoundDisplay.vue?vue&type=script&lang=js"
import style0 from "./RoundDisplay.vue?vue&type=style&index=0&id=f8fa05f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8fa05f8",
  null
  
)

export default component.exports